export default "__VITE_ASSET__b10ca4d9__"